var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewLogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 232.705,
    height: 33.427,
    viewBox: "0 0 232.705 33.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1.025,
    x2: 0.5,
    y2: -0.25,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd16c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3bd1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1.025,
    x2: 0.5,
    y2: -0.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 1.648,
    x2: 0.5,
    y2: -1.479,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(-378.57 154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(378.57 -154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M37.211,53.56H32.332A3.762,3.762,0,0,1,28.57,49.8V20.14l4.845.033a3.759,3.759,0,0,1,3.736,3.756l.013,6.008a6.617,6.617,0,0,0-.922.334,6.264,6.264,0,0,0-3.488,4c-.428,1.5-.508,3.929,1.537,6.957a14.592,14.592,0,0,0,1.23,1.564A20.688,20.688,0,0,0,37.2,44.452l.02,9.108Z",
    transform: "translate(-28.57 -20.133)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M65.994,20.137V49.788a3.762,3.762,0,0,1-3.762,3.762H57.3l.02-9.115A19.664,19.664,0,0,0,59,42.771a14.266,14.266,0,0,0,1.223-1.557c2.038-3.021,1.958-5.446,1.53-6.957a6.4,6.4,0,0,0-4.4-4.33l-.033-6.014a3.766,3.766,0,0,1,3.762-3.782h4.912Z",
    transform: "translate(-38.101 -20.13)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M51.895,45.813a12.008,12.008,0,0,1-1.036,1.323,24.034,24.034,0,0,1-5.306,4.27,24.336,24.336,0,0,1-5.3-4.264,13.634,13.634,0,0,1-1.036-1.323c-2.586-3.829-1.183-6.656,1.022-7.652a4.019,4.019,0,0,1,5.319,1.758,4.017,4.017,0,0,1,5.326-1.751c2.2,1,3.6,3.816,1.016,7.645Z",
    transform: "translate(-31.639 -25.986)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(420.41 -150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M109.186,26.21h3.695V40.2h7.108v3.2H109.18V26.21Z",
    transform: "translate(-109.18 -22.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M137.036,32.925c1.966,0,5.814.622,5.814,6.618,0,4.911-2.742,7.262-6.205,7.262s-5.765-2.224-5.765-6.9c0-5.4,3.436-6.982,6.15-6.982Zm2.12,7c0-2.792-.595-4.394-2.274-4.394s-2.351,1.6-2.351,3.953.336,4.68,2.3,4.68c1.652,0,2.329-1.6,2.329-4.24Z",
    transform: "translate(-118.932 -25.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M167.131,33.626a22.091,22.091,0,0,1,.853,5.792c0,4.884-2.147,7.675-6.332,7.675-3.183,0-4.7-1.476-4.7-4.653V33.625h3.618v8.248c0,1.421.1,2.428,1.476,2.428,1.889,0,2.428-2.379,2.428-4.708a24.761,24.761,0,0,0-.881-5.974h3.54Z",
    transform: "translate(-130.648 -26.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M191.43,36.7c0,3.9-3.953,4.68-7.081,4.807a2.816,2.816,0,0,0,2.973,2.56,5.779,5.779,0,0,0,3.232-1.112l1.035,2.406a8.146,8.146,0,0,1-4.73,1.448c-4.394,0-6.15-2.742-6.15-6.618s2.2-7.262,6.437-7.262c2.61,0,4.289,1.316,4.289,3.777Zm-4.471-1.239c-1.756,0-2.687,1.734-2.764,3.513,1.679-.05,4.086-.463,4.086-2.246a1.207,1.207,0,0,0-1.316-1.266Z",
    transform: "translate(-141.325 -25.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M219.992,23.37V42.124h-4.03V34.366h-7.136v7.758H204.79V23.37h4.036v7.472h7.136V23.37Z",
    transform: "translate(-152.147 -21.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M250.539,42.567l.281,2.847h-3.359l-.2-1.437-.143-.028a4.315,4.315,0,0,1-3.777,1.861c-4.091,0-5.473-3.1-5.473-6.91,0-4.961,2.483-8.21,7.472-8.21a16.692,16.692,0,0,1,5.187,1.046v10.83Zm-3.887-8.656a4.673,4.673,0,0,0-1.778-.308c-2.313,0-3.1,2.313-3.1,5.077,0,2.285.479,4.289,2.566,4.289a2.182,2.182,0,0,0,2.313-2.114V33.917Z",
    transform: "translate(-167.013 -24.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M271.21,51.342h-3.92V31.686a20.79,20.79,0,0,1,5.924-.986c4.515,0,6.712,2.538,6.712,7.477s-2.34,7.67-6.123,7.67a5.924,5.924,0,0,1-2.593-.622v6.123ZM272.647,33.8a6.647,6.647,0,0,0-1.437.171v8.176a3.836,3.836,0,0,0,1.977.567c2.169,0,2.792-2.257,2.792-4.317,0-2.709-.876-4.6-3.326-4.6Z",
    transform: "translate(-180.234 -24.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M299.23,51.342h-3.92V31.686a20.79,20.79,0,0,1,5.924-.986c4.515,0,6.712,2.538,6.712,7.477s-2.34,7.67-6.123,7.67a5.924,5.924,0,0,1-2.593-.622v6.123ZM300.667,33.8a6.648,6.648,0,0,0-1.437.171v8.176a3.836,3.836,0,0,0,1.977.567c2.169,0,2.792-2.257,2.792-4.317,0-2.709-.875-4.6-3.326-4.6Z",
    transform: "translate(-192.826 -24.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M325.249,20.3a2.089,2.089,0,0,1,2.2,2.059,2.041,2.041,0,0,1-2.2,2.059,2.014,2.014,0,0,1-2.169-2.059A2.063,2.063,0,0,1,325.249,20.3Zm-1.944,20.449V26.45h3.92v14.3Z",
    transform: "translate(-205.305 -20.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M336.7,45.419V33.768l-.253-2.654h3.271L340,32.8a4.993,4.993,0,0,1,4.256-2.114c2.792,0,4.482,1.58,4.482,4.966v9.757h-3.92v-9c0-1.553-.253-2.709-1.751-2.709a2.438,2.438,0,0,0-2.456,2.538v9.168h-3.92Z",
    transform: "translate(-211.314 -24.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M375.406,34.823c0,4.256-4.317,5.1-7.73,5.247a3.07,3.07,0,0,0,3.243,2.792,6.287,6.287,0,0,0,3.524-1.211l1.129,2.621a8.912,8.912,0,0,1-5.159,1.58c-4.8,0-6.712-2.99-6.712-7.218s2.4-7.923,7.02-7.923c2.847,0,4.68,1.437,4.68,4.119Zm-4.878-1.354c-1.916,0-2.935,1.889-3.017,3.838,1.833-.055,4.454-.507,4.454-2.456A1.319,1.319,0,0,0,370.528,33.469Z",
    transform: "translate(-223.56 -24.978)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M388.293,41.585a8.913,8.913,0,0,0,4.119,1.382c1.046,0,1.806-.424,1.806-1.492s-1.013-1.382-2.23-1.751c-2.114-.622-4.256-1.437-4.256-4.427s2.368-4.6,5.275-4.6a7.679,7.679,0,0,1,5.33,2.059l-1.806,2.285a5.4,5.4,0,0,0-3.3-1.492c-.93,0-1.69.369-1.69,1.3,0,1.1.931,1.465,2.2,1.861,2.059.65,4.372,1.41,4.372,4.344,0,3.188-2.23,4.8-5.5,4.8a9.921,9.921,0,0,1-5.385-1.492L388.3,41.6Z",
    transform: "translate(-234.134 -24.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M410.633,41.585a8.912,8.912,0,0,0,4.119,1.382c1.046,0,1.806-.424,1.806-1.492s-1.013-1.382-2.23-1.751c-2.114-.622-4.256-1.437-4.256-4.427s2.368-4.6,5.275-4.6a7.679,7.679,0,0,1,5.33,2.059l-1.806,2.285a5.394,5.394,0,0,0-3.3-1.492c-.931,0-1.69.369-1.69,1.3,0,1.1.931,1.465,2.2,1.861,2.059.65,4.372,1.41,4.372,4.344,0,3.188-2.23,4.8-5.5,4.8a9.921,9.921,0,0,1-5.385-1.492l1.074-2.764Z",
    transform: "translate(-244.174 -24.974)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14077",
    "data-name": "Path 14077",
    d: "M1.807-1.232A5.167,5.167,0,0,1-.819-1.889,4.693,4.693,0,0,1-2.6-3.7a5.265,5.265,0,0,1-.644-2.614A5.246,5.246,0,0,1-2.6-8.939a4.718,4.718,0,0,1,1.784-1.8,5.167,5.167,0,0,1,2.627-.657,5.05,5.05,0,0,1,2.59.657,4.744,4.744,0,0,1,1.772,1.8,5.246,5.246,0,0,1,.644,2.627A5.265,5.265,0,0,1,6.169-3.7,4.719,4.719,0,0,1,4.4-1.889,5.05,5.05,0,0,1,1.807-1.232Zm.917-2.453L1.237-6.114H2.625L4.236-3.685ZM1.807-2.223A4.039,4.039,0,0,0,3.9-2.743a3.55,3.55,0,0,0,1.363-1.45,4.525,4.525,0,0,0,.483-2.119,4.451,4.451,0,0,0-.483-2.106A3.655,3.655,0,0,0,3.9-9.868,3.966,3.966,0,0,0,1.807-10.4a4.1,4.1,0,0,0-2.119.533,3.691,3.691,0,0,0-1.4,1.45,4.36,4.36,0,0,0-.5,2.106,4.432,4.432,0,0,0,.5,2.119,3.585,3.585,0,0,0,1.4,1.45A4.175,4.175,0,0,0,1.807-2.223ZM-.225-3.685V-9.013H2.2a1.879,1.879,0,0,1,1.326.446,1.571,1.571,0,0,1,.483,1.214A1.541,1.541,0,0,1,3.53-6.163,1.879,1.879,0,0,1,2.2-5.717H1.039v2.032ZM1.039-6.708H2.055a.855.855,0,0,0,.5-.136.516.516,0,0,0,.2-.458.484.484,0,0,0-.2-.446.919.919,0,0,0-.5-.124H1.039Z",
    transform: "translate(604.462 -138.608)",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/new_logo.6896a2c792de32c5aff252d74ed80099.svg";
export { ForwardRef as ReactComponent };